import { deleteBalancesCache } from '@polaris/core/services'
import { useMutation } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { balancesByChainsAtom } from '@/src/stores/balances/atom'
import { mpcWalletAddressesWithNamadaOverrideAtom } from '@/src/stores/mpc/atoms'

export const useDeleteBalancesCache = () => {
  const unfilteredBalancesByChains = useAtomValue(balancesByChainsAtom)
  const { data: mpcAddresses } = useAtomValue(
    mpcWalletAddressesWithNamadaOverrideAtom,
  )

  const addressChainIdSet = useMemo(() => {
    // Get all regular wallet addresses with their chain IDs
    const regularAddresses = unfilteredBalancesByChains.flatMap(
      (balanceByChain) =>
        balanceByChain.addresses.map((address) => ({
          chain_id: balanceByChain.chain_id,
          address,
        })),
    )

    // For MPC addresses, use empty chain_id to invalidate ALL chains
    const mpcAddressList = Object.values(mpcAddresses ?? {}).filter(Boolean)
    const mpcAddressEntries = mpcAddressList.map((address) => ({
      chain_id: '',
      address,
    }))

    return [...regularAddresses, ...mpcAddressEntries]
  }, [unfilteredBalancesByChains, mpcAddresses])

  return useMutation({
    mutationKey: ['delete-balances-cache'],
    retry: false,
    mutationFn: () =>
      deleteBalancesCache({
        addressChainIdSet,
      }),
  })
}
